
























import { Component, Vue, Prop } from "vue-property-decorator";
import CModal from "@/basics/modal/CModal.vue";
import TextInput from "@/basics/inputs/TextInput.vue";
import CButton from "@/basics/buttons/CButton.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";
import CSelect from "@/basics/selects/CSelect.vue";

export interface SelectOption {
  value: string;
  text: string;
}

@Component({
  components: { CModal, TextInput, CButton, ModalTitle, CSelect },
  watch: {
    show() {
      (this as SelectBooleanModal).reset();
    }
  }
})
export default class SelectBooleanModal extends Vue {
  @Prop({ type: String, required: false, default: "" }) name!: string;
  @Prop({ type: Boolean, required: false, default: true }) show!: boolean;
  @Prop({ type: Boolean, required: false, default: true }) value!: boolean;
  @Prop({ type: Array, required: true }) options!: SelectOption[];
  selectedValue: boolean = true;
  status: null | "saving" | "saved" | "error" = null;
  error = "";

  reset() {
    this.selectedValue = this.value;
    this.status = null;
  }

  close() {
    if (this.show) {
      this.$emit("close", { status: this.status });
    }
  }

  async save() {
    if (this.show) {
      try {
        this.status = "saving";
        await new Promise((resolve, reject) => {
          this.$emit("save", this.selectedValue, resolve, reject);
        });
        this.status = "saved";
      } catch (e) {
        this.status = "error";
        this.error = "保存に失敗しました";
      }
    }
  }
}
